import * as THREE from 'three'

export const customStartPropAssetKeys = [
    'Teddy',
    'ToyCar',
    'Rainbow',
    'Cloud',
    'Lvl04Bridge',
    'Lvl04SpaceDonut',
    'Lvl04StarA',
    'Lvl04StarB',
    'Lvl04PirsmA',
    'Lvl04PirsmB',
    'Lvl04SpaceHeart',
    'LVL2_Clock',
    'LVL2_Geometries',
    'LVL2_Globe',
    'LVL2_MathScience',
    'LVL3_Folder',
    'LVL3_Paperplane',
    'LVL3_Window1',
    'LVL3_Window2',
] as const

export type CustomStartPropAssetKey = (typeof customStartPropAssetKeys)[number]

export type CustomPlatformAssemblyConfig = {
    arcCoverage: number
    centerPosition: readonly [number, number, number]
    contentVariantSequence: readonly (0 | 1 | 2)[]
    count: number
    name: string
    openingDirectionOffset: number
    radius: number
    region: 1 | 2 | 3 | 4
    scale: number
}

export type CustomPlatformPropPlacementConfig = {
    clones?: number
    cloneSpacingZ?: number
    name: string
    platformRegion: 1 | 2 | 3 | 4
    propAsset: CustomStartPropAssetKey
    propPosition: readonly [number, number, number]
    propRotation: readonly [number, number, number]
    propScale: number
    platformScale: number
}

export type IndividualContentPlatformPlacementConfig = {
    contentVariant: 0 | 1 | 2
    name: string
    platformPosition: readonly [number, number, number]
    platformRegion: 1 | 2 | 3 | 4
    platformRotation: readonly [number, number, number]
    platformScale: number
}

export function createWorldMatrix(
    position: readonly [number, number, number],
    rotation: readonly [number, number, number],
    scale: number,
) {
    return new THREE.Matrix4().compose(
        new THREE.Vector3(position[0], position[1], position[2]),
        new THREE.Quaternion().setFromEuler(
            new THREE.Euler(rotation[0], rotation[1], rotation[2]),
        ),
        new THREE.Vector3(scale, scale, scale),
    )
}
